export const SearchProfileIncludes = [
  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'Phone',
    value: 'phone',
  },
  {
    label: 'Website',
    value: 'website',
  },
  {
    label: 'Social Media',
    value: 'social_media',
  },
  {
    label: 'Company Attached',
    value: 'company_attached',
  },
];

export enum SanctionsStatus {
  All = 'false',
  OnlyAlert = 'true',
}

export const SearchPeopleStatus = [
  {
    label: 'All Status',
    value: SanctionsStatus.All,
  },
  {
    label: 'Only Alerts',
    value: SanctionsStatus.OnlyAlert,
  },
];

export interface IPropsDataPeopleContribute {
  type_of_contribution: TypeContributePeople;
  relation_to_data: string;
  note: string;
  is_confirm: boolean;
  contribution_contact_people_profile: Array<{
    address: string;
    email: string;
    phone_number: string;
    phone_code: string;
  }>;
  contribution_social_media_people_profile: Array<{
    website: string;
  }>;
}

export enum TypeContributePeople {
  ContactPeopleProfile = 'contact_people_profile',
  SocialPeopleCompanyProfile = 'social_media_people_profile',
}

export const TYPE_CONTRIBUTE_PEOPLE = [
  { value: TypeContributePeople.ContactPeopleProfile, label: 'Contact - Personal Profile' },
  { value: TypeContributePeople.SocialPeopleCompanyProfile, label: 'Social Media - Personal Profile' },
];
